import { number, string, func, node, object } from 'prop-types';
import React, { useState, useEffect } from 'react';
import setClass from '../../common/set-class';
const noop = () => { };
const defaultIndex = 0;
const setIndex = (opts) => {
    const { i, activeWatch, selectedIndex } = opts;
    if (activeWatch !== undefined) {
        return i === activeWatch;
    }
    return i === selectedIndex;
};
const ButtonGroup = (props) => {
    const { children, onToggle, className, style, initialSelected, activeWatch, } = props;
    const [selectedIndex, setSelectedIndex] = useState(initialSelected);
    /* consumer call use the onToggle handler */
    useEffect(() => {
        if (onToggle) {
            onToggle(selectedIndex);
        }
    }, [selectedIndex]);
    /* control the index using the state variable provided by the parent */
    useEffect(() => {
        setSelectedIndex(activeWatch);
    }, [activeWatch]);
    const wrapChildren = () => React.Children.map(children, (child, i) => React.cloneElement(child, {
        onClick: () => {
            if (child.props.onClick) {
                child.props.onClick();
            }
            setSelectedIndex(i);
        },
        isActive: setIndex({ i, activeWatch, selectedIndex }),
    }));
    return (React.createElement("div", { style: style, className: setClass(['b-btn-group', 'b-flex-items', className]) }, wrapChildren()));
};
ButtonGroup.propTypes = {
    children: node,
    onToggle: func,
    style: object,
    className: string,
    initialSelected: number,
    activeWatch: number,
};
ButtonGroup.defaultProps = {
    children: React.createElement("span", null),
    onToggle: noop,
    style: {},
    className: '',
    initialSelected: defaultIndex,
    activeWatch: defaultIndex,
};
export default ButtonGroup;
